<script setup>
import {
  watchEffect,
  watch,
  ref,
  onMounted,
  onBeforeUnmount,
  nextTick,
  computed,
} from "vue";
import { OSSImageCompress } from "@/utils/index.js";
import { useRoute } from "vue-router";
import { post, get } from "@/apis";

import BookletMenu from "./components/BookletMenu.vue";
import AudioAlbum from "./components/AudioAlbum.vue";
import VideoAlbum from "./components/VideoAlbum.vue";
import PointReading from "./components/PointReading.vue";
import Empty from "@/components/Empty.vue";

import currentLearn from "@/assets/current-learn.png";
import OpenApp from "@/components/OpenApp.vue";
import ArrowUp from "@/assets/arrow-up.png";
import ArrowDown from "@/assets/arrow-down.png";
import DefaultCover from "@/assets/default-cover.png";
import ScrollOpenApp from "../../components/ScrollOpenApp.vue";
import IconBookLock from "@/assets/icon-book-lock.png";
import IconBookVip from "@/assets/icon-book-vip.png";
import SideCloseBtn from "@/assets/side-close-btn.png";
import NotPutaway from "../../components/NotPutaway.vue";
import AppFn from "../../components/AppFn.vue";

const { query } = useRoute();

const bookRankList = ref([]);
const rankClassify = ref([]);
const activeBook = ref(0);
const active = ref(0);
const selectRankVisible = ref(false);
const openAppRef = ref();
const isBookEmpty = ref(false);
const isRankEmpty = ref(false);
const isPutaway = ref(true);
const bottomAdSetting = ref({});

const getBookRank = async (requestClassify) => {
  const res = await post(
    "/api/classpal/app/v1/h5/app-books-rank/app/books/rank/list",
    {
      bookId: query.booksId,
    },
  );
  bookRankList.value = res.data;
  if (res.data.length && requestClassify) {
    getRankClassify(res.data[activeBook.value].id);
  }
};

const getBookDetail = async (id) => {
  const res = await get("/api/classpal/app/v1/h5/app-books/books/info/detail", {
    id,
  });
  isPutaway.value = res.data.status;
  document.title = res.data.bookName;
};

const getRankClassify = async (id) => {
  const res = await post(
    "/api/classpal/app/v1/h5/books-rank-classify/books/rank/classify/list",
    {
      rankId: id,
    },
  );
  rankClassify.value = res.data;
  isRankEmpty.value = !res.data.length;

  // const bookInCodes = res.data.filter((item) => item.type === "BOOK_IN_CODES");
  // rankClassify.value = bookInCodes.length ? [bookInCodes[0]] : [];
  // isRankEmpty.value = !rankClassify.value.length;
  await nextTick();
};

const selectBookRank = (index) => {
  if (activeBook.value === index) {
    return;
  }
  activeBook.value = index;
  getBookRank(true);
  selectRankVisible.value = false;
};

const handleToApp = () => {
  openAppRef.value.handleToApp({ routePath: "bookDetailPage" });
};

// 获取底部广告设置
const getBottomAdSetting = async () => {
  const res = await post(
    "/api/classpal/app/v1/advertisement/getAdvertisementTrends",
    {
      advertisementType: "bookBottomBanner",
    },
  );
  bottomAdSetting.value = res.data?.[0] || {};
};

const onClickBottomAd = () => {
  // const { redirectType, redirectUri, redirectAppId } = bottomAdSetting.value;
  // // 无跳转
  // if (redirectType === 0) {
  //   return;
  // }
  // // 链接
  // if (redirectType === 1) {
  //   window.location.href = redirectUri;
  //   return;
  // }
  // // 小程序
  // if (redirectType === 2) {
  //   return;
  // }
  // // 基础图文
  // if (redirectType === 3) {
  //   return;
  // }
  // console.log(redirectType);
};

const onClickCloseAd = () => {};

watchEffect(async () => {
  if (query.booksId) {
    await getBottomAdSetting();
    await getBookRank(false);
    activeBook.value = bookRankList.value.findIndex(
      (item) => item.id == query.rankId,
    );
    if (activeBook.value === -1) {
      isBookEmpty.value = true;
    } else {
      getRankClassify(bookRankList.value[activeBook.value]?.id);
      getBookDetail(query.booksId);
      isBookEmpty.value = false;
    }
  }
});
</script>

<template>
  <div class="container">
    <!-- <van-sticky z-index="3000"> -->
    <div v-if="!isPutaway">
      <NotPutaway />
    </div>
    <div v-if="isBookEmpty" style="width: 100%; height: 100%">
      <Empty />
    </div>
    <div class="container-header" v-else>
      <div class="title" @click.stop="selectRankVisible = !selectRankVisible">
        <van-image
          class="book-img"
          :src="bookRankList[activeBook]?.picUrl"
          :loading-icon="DefaultCover"
        />
        <span class="book-title">
          {{ bookRankList[activeBook]?.productItemName }}
        </span>
        <van-image
          v-show="bookRankList.length > 1 && selectRankVisible"
          class="book-arrow"
          :src="ArrowUp"
        />
        <van-image
          v-show="bookRankList.length > 1 && !selectRankVisible"
          class="book-arrow"
          :src="ArrowDown"
        />
      </div>
      <van-tabs
        v-if="!isRankEmpty"
        v-model:active="active"
        line-height="0"
        shrink
        class="book-tabs"
        title-active-color="#FF8912"
      >
        <van-tab v-for="rank in rankClassify" :key="rank.id">
          <template #title>
            <div class="book-tab-title-box">
              <span class="book-tab-title">{{ rank.name }}</span>
              <van-image
                v-if="rank.isLock && rank.lockFlag === 2"
                :src="IconBookLock"
                class="book-tab-title-icon book-tab-title-icon-lock"
              />
              <!-- <van-image
                v-if="rank.isLock && rank.lockFlag === 1"
                :src="IconBookVip"
                class="book-tab-title-icon book-tab-title-icon-vip"
              /> -->
            </div>
          </template>
          <div></div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- </van-sticky> -->

    <div class="booklet-container" :class="bottomAdSetting.id ? 'has-ad' : ''">
      <Empty v-if="isRankEmpty" />
      <!-- 图书资源 -->
      <BookletMenu
        v-if="rankClassify[active]?.type === 'BOOK_IN_CODES'"
        :rank="rankClassify[active]"
      />

      <!-- 音频专辑 -->
      <AudioAlbum
        v-if="rankClassify[active]?.type === 'AUDIO_ALBUM'"
        :rank="rankClassify[active]"
      />

      <!-- 视频专辑 -->
      <VideoAlbum
        v-if="rankClassify[active]?.type === 'VIDEO_ALBUM'"
        :rank="rankClassify[active]"
      />

      <!-- 点读书 -->
      <PointReading
        v-if="rankClassify[active]?.type === 'POINT_READING'"
        :rank="rankClassify[active]"
      />

      <!-- 底部广告 -->
      <div v-if="bottomAdSetting.id" class="bottom-ad" @click="onClickBottomAd">
        <van-image
          :src="bottomAdSetting.coverUrl"
          fit="contain"
          class="bottom-ad-img"
        />
        <div class="side-close-btn" @click.stop="onClickCloseAd">
          <van-image :src="SideCloseBtn" />
        </div>

        <wx-open-launch-weapp
          id="launch-btn"
          :appid="'wxf51ee80a1aa00670'"
          :path="bottomAdSetting.redirectUri"
          style="
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            -webkit-tap-highlight-color: transparent !important;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0) !important;
            user-select: none;
            outline: 0;
          "
        >
          <component :is="'script'" v-bind="{ type: 'text/wxtag-template' }">
            <button
              style="
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                opacity: 0;
                -webkit-tap-highlight-color: transparent !important;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0) !important;
                user-select: none;
                outline: 0;
              "
            ></button>
          </component>
        </wx-open-launch-weapp>
      </div>
    </div>
  </div>

  <van-popup
    v-model:show="selectRankVisible"
    close-on-popstate
    position="top"
    class="rank-popup"
    duration="0"
  >
    <div
      v-for="(book, index) in bookRankList"
      :key="book.id"
      :class="['book-rank', activeBook === index ? 'book-rank-active' : '']"
      @click.stop="selectBookRank(index)"
    >
      <van-image :src="book?.picUrl" class="book-rank-img" />
      <div class="book-rank-r">
        <span
          v-middleEllipsisMulti="{
            text: book.productItemName,
          }"
          class="book-rank-title"
        >
        </span>
        <span class="book-rank-tips">共{{ book.contentsNum }}页配套资源</span>
      </div>
      <div class="book-active" v-if="activeBook === index">
        <van-image :src="currentLearn" class="book-active-img" />
        <span class="book-active-text">当前学习</span>
      </div>
    </div>
  </van-popup>

  <AppFn @imgLoaded="onImgLoaded" />

  <OpenApp
    ref="openAppRef"
    @click.stop="handleToApp"
    :appParams="{ routePath: 'bookDetailPage' }"
  />

  <ScrollOpenApp
    @confirm="handleToApp"
    :init-popup="true"
    :appParams="{ routePath: 'bookDetailPage' }"
  />
</template>

<style lang="scss" scoped>
.container {
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.title {
  height: 44px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 3000;
  background-color: #fff;
}
.book-img {
  width: 24px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 4px;
  overflow: hidden;
}
.book-title {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin-left: 8px;
  color: #000000d9;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.book-arrow {
  width: 14px;
  height: 8px;
  flex-shrink: 0;
  margin-left: 8px;
}
.book-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  &:deep(.van-tabs__wrap) {
    height: 52px;
    .van-tabs__nav {
      padding-bottom: 0;
      padding-left: 0;
      .van-tab {
        font-size: 16px;
        font-weight: normal;
        padding: 0 15px;
        &:first-child {
          padding-left: 16px;
        }
      }
      .book-tab-title-box {
        display: flex;
        align-items: center;
      }
      .book-tab-title-icon {
        margin-left: 8px;
        &-lock {
          width: 24px;
          height: 24px;
        }
        &-vip {
          width: 35px;
          height: 20px;
        }
      }
      .van-tab--active {
        font-size: 18px;
        font-weight: 600;
        .book-tab-title {
          position: relative;
          &::after {
            content: "";
            position: absolute;
            bottom: -7px;
            right: -8px;
            width: 14px;
            height: 12px;
            background-image: url("@/assets/select.png");
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
        .book-tab-title-icon {
          margin-left: 12px;
        }
      }
      .van-tabs__line {
        background-color: transparent;
      }
    }
  }
  &:deep(.van-tabs__content) {
    flex: 1;
    background-color: #f7f7f7;
  }
}
.rank-popup {
  max-width: 100vw;
  width: 100vw;
  max-height: 398px;
  top: 44px;
  transform: none;
  padding: 18px 20px;
  background-color: #f7f7f7;
  border-radius: 0 0 24px 24px;
}
.book-rank {
  background-color: #fff;
  height: 104px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  border-radius: 12px;
  border: 4px solid transparent;
  position: relative;
  &:not(:last-child) {
    margin-bottom: 18px;
  }
  .book-rank-img {
    width: 76px;
    height: 102px;
    position: absolute;
    top: -10px;
    left: 12px;
    &:deep(.van-image__img) {
      border-radius: 12px;
    }
  }
  .book-rank-r {
    min-width: 0;
    flex: 1;
    margin-left: 86px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding: 12px 0;
    box-sizing: border-box;
    .book-rank-title {
      font-size: 16px;
      color: #000000d9;
      font-weight: 600;
    }
    .book-rank-tips {
      font-size: 12px;
      color: #0000004d;
      margin-top: 8px;
    }
  }
}
.book-rank-active {
  border-color: #ffa431;
}
.book-active {
  position: absolute;
  bottom: 16px;
  left: -10px;
  width: 64px;
  height: 28px;
}
.book-active-img {
  width: 64px;
  height: 28px;
  position: absolute;
}
.book-active-text {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  position: absolute;
  left: 0;
  line-height: 24px;
  z-index: 10;
  white-space: nowrap;
  width: 64px;
  text-align: center;
}

.rank-active {
  font-size: 18px;
  font-weight: 600;
  &::after {
    content: "";
    position: absolute;
    bottom: 10px;
    right: 2px;
    width: 14px;
    height: 12px;
    background-image: url("@/assets/select.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
}
.booklet-container {
  background-color: #f7f7f7;
  flex: 1;
  overflow-y: scroll;
  padding-bottom: 0;
  .has-ad {
    padding-bottom: 168px;
  }
}
.bottom-ad {
  position: relative;
  width: 100vw;
  height: 168px;
  border-radius: 24px 24px 0 0;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
}
.bottom-ad-img {
  width: 100%;
  height: 168px;
  display: block;
}
.side-close-btn {
  position: absolute;
  top: 43px;
  right: 0;
  width: 22px;
  height: 82px;
}
</style>
